import { useEffect, useRef, useState } from 'react';

const steps = [
  {
    num: '01',
    title: '레슨 상담',
    desc: '레슨 목표와 현재 실력, 선호하는 장르를 상담합니다. 맞춤 커리큘럼을 설계해 드립니다.',
    icon: 'ri-chat-1-line',
  },
  {
    num: '02',
    title: '정규 레슨',
    desc: '개인별 맞춤 커리큘럼으로 체계적인 학습을 진행합니다. 매 레슨마다 피드백과 과제 제공.',
    icon: 'ri-calendar-check-line',
  },
  {
    num: '03',
    title: '녹음 & 결과물',
    desc: '학습한 내용을 바탕으로 자신의 곡을 녹음하고 완성도 높은 결과물을 만들어냅니다.',
    icon: 'ri-record-circle-line',
  },
];

export default function ProcessSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-studio-black py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="w-full">
        {/* Section header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-studio-gray/30 font-bebas text-[clamp(60px,10vw,140px)] leading-none block">
            02
          </span>
          <h2
            className="text-white font-bebas uppercase leading-none -mt-6 md:-mt-12"
            style={{ fontSize: 'clamp(40px, 6vw, 80px)', lineHeight: 1 }}
          >
            레슨 진행 과정
          </h2>
          <p className="text-studio-gray font-sans text-lg md:text-xl mt-4">
            3단계로 완성되는 나만의 음악 여정
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`relative bg-studio-card border border-studio-border rounded-lg p-8 md:p-10 group hover:border-studio-muted transition-all duration-500 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              {/* Step number */}
              <span className="text-studio-gray/20 font-bebas text-5xl md:text-6xl leading-none block mb-4">
                {step.num}
              </span>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center border border-studio-muted rounded-lg mb-5 group-hover:border-studio-silver transition-colors">
                <i className={`${step.icon} text-studio-silver text-xl`} />
              </div>

              {/* Title */}
              <h3 className="text-white font-bebas text-2xl md:text-3xl uppercase mb-3">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-studio-silver font-sans text-sm leading-relaxed">
                {step.desc}
              </p>

              {/* Connector line for desktop */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 border-t border-studio-muted" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}